export enum PaymentMethodAndOptions {
    Mpesa = 'mpesa',
    TotalDueAmount = 'totalDueAmount',
    CustomAmount = 'customAmount',
    CreditCard='creditCard'
}